import DataMap from 'assets/components/dataMap/DataMap';
import { useModalForm } from 'assets/components/form/modalForm/ModalForm';
import FormatValue from 'assets/components/formatValue/FormatValue';
import Icon from 'assets/components/icon/Icon';
import NumberInput from 'assets/components/inputs/number/NumberInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import { useSalesContractProvider } from '../../../Sales.Contract.Hooks';
import { ContractAdjustForm } from '../Contract.AdjustDistributions';
import Theme from 'assets/themes/Theme.Common';

const ContractAdjustDistributionsSurcharges = () => {
  const { lang } = getLocales();
  const { form } = useModalForm<ContractAdjustForm>();
  const { selected } = useSalesContractProvider();

  return (
    <FormWrapper>
      <p
        style={{
          backgroundColor: Theme.Color.warning,
          color: 'white',
          padding: `${Theme.Size.M} ${Theme.Size.L}`,
          fontWeight: 'bold',
          marginTop: 0,
        }}
      >
        {lang.contractUnrestrictedUpdateWarningMessage}
      </p>
      <table className={ThemeTableSimple}>
        <thead>
          <tr>
            <th>{lang.name}</th>
            <th>{lang.oldAmount}</th>
            <th>{lang.amount}</th>
            <th>{lang.mandatory}</th>
          </tr>
        </thead>
        <tbody>
          <DataMap
            data={form.data.subfees}
            render={({ data: subfee }) => {
              const oldSubfee = selected.subfees?.find((it) => it.subfeeId === subfee.subfeeId);
              return (
                <tr key={subfee.subfeeId}>
                  <td>{subfee.name}</td>
                  <td>
                    <FormatValue value={`$${(oldSubfee?.amount ?? 0).toFixed(2)}`} />
                  </td>
                  <td>
                    <NumberInput
                      name="amount"
                      value={subfee.amount}
                      onChange={({ amount }) => {
                        const tempSubfees = [...(form?.data?.subfees || [])];
                        const updatedSubfees = tempSubfees?.map((it) =>
                          it.subfeeId === subfee.subfeeId ? { ...it, amount } : it
                        );
                        form.update({
                          subfees: updatedSubfees,
                        });
                      }}
                      iconBefore={<Icon class={'fas-dollar-sign'} />}
                      min={0}
                      step={0.01}
                      roundOnBlur
                    />
                  </td>
                  <td>{subfee.isMandatory ? <Icon class="fas-check" /> : <Icon class="fas-times" />}</td>
                </tr>
              );
            }}
          />
        </tbody>
      </table>
    </FormWrapper>
  );
};

export default ContractAdjustDistributionsSurcharges;
